import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import * as UsuarioService from 'services/usuario.service'

const SerieDocumentoFormGroup = ({ idFormato, iError, iTouched, fIsSubmitting }) => {
  const [usuarios, setUsuarios] = React.useState([])

  React.useEffect(() => {
    UsuarioService.getSelect().then(({ data }) => {
      setUsuarios(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='USUARIO' md={4} htmlFor={`${idFormato}-select-usuario`} alignRightAt='md' />
      <Col md={8}>
        <Field name='idUsuario'>
          {({ field }) => (
            <Form.Select
              {...field}
              id={`${idFormato}-select-usuario`}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Todos</option>
              {usuarios.map((x, k) => (
                <option key={k} value={x._id}>
                  {x.username}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoFormGroup)
